export const NAMESPACES = ['common', 'admin', 'errors'] as const

export type TranslationNamespace = (typeof NAMESPACES)[number]
